import React, {useState} from 'react';
import { useHistory } from "react-router-dom";

// sample to use functional components with local state
const Hook = () => {
  const history = useHistory(); // router hook function
  
  const [localState, setLocalState] = useState({
    dataOne: false,
    dataTwo: 0,
  }); // hook setState function

  const toogleButton = () =>{
    setLocalState(prevState => {
      return { ...prevState, dataOne: !localState.dataOne  };
    });
  }
  const increment = () =>{
    setLocalState(prevState => {
      return { ...prevState, dataTwo: localState.dataTwo + 1 };
    });
  }

  const handleNext = () => {
    history.push('form-one')
  }

  return (
    <div>
      <h1>Sample functional components with local state</h1>
      <div>
        dataOne : {JSON.stringify(localState.dataOne)}
        <button onClick={toogleButton}>Toggle</button>
      </div> 
      <div>
        dataOne : {localState.dataTwo}
        <button onClick={increment}>Increment</button>
      </div> 
    
   
      <button onClick={handleNext}>Next</button>
    </div>
  )
}

export default Hook